<template>
  <div id="search_wrapper">
    <div v-if="keyword">
      <!-- @submitでページがリロードされるのをprevent。キーボードから検索実行した際には、clickSearchButton関数が作動し、
          aに設定した#search_form_buttonをクリックし検索&ページ遷移
       -->
      <form
        class="temporary_search_form"
        action="#"
        @submit.prevent="clickSearchButton"
      >
        <input
          type="search"
          v-model="keyword"
          placeholder="フリーワードで検索"
          class="search_form search_form_item"
        />
      </form>
      <button
        @click="search"
        class="search_button search_form_item"
        style="padding-bottom: 2px"
      >
        検索
      </button>
    </div>
    <div v-if="!keyword">
      <form
        class="temporary_search_form"
        action="#"
        @submit.prevent="clickSearchButton"
      >
        <input
          type="search"
          v-model="keyword"
          :placeholder="icon"
          class="search_form search_form_item"
        />
      </form>
      <!-- <input type="text" v-model="keyword" :placeholder="icon" class="search_form search_form_item"> -->
      <a id="search_form_button" to="">
        <button
          class="search_button search_form_item"
          style="padding-bottom: 2px"
        >
          検索
        </button>
      </a>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";

export default {
  components: {},
  data() {
    return {
      keyword: "",
      showHistory: false,
      keywordToURL: "",
      icon: " フリーワードで検索",
    };
  },
  props: {
    mode: {
      type: Number,
    },
  },
  methods: {
    clickSearchButton() {
      if (this.keyword) {
        var clickTarget = document.getElementById("search_form_button");
        this.search();
        clickTarget.click();
      } else {
        return false;
      }
    },
    async search() {
      window.location.href =
        process.env.VUE_APP_BASE_COMMUNICATION_URL +
        "/review/post?s=" +
        this.keyword +
        "&d=&ut=&tm=&a=&h=&st=post";
    },

    //検索履歴クリックで反映用。検索履歴クリックで検索キーワードをクリックしたワードに変換
    async updateKeyword(updated_keyword) {
      this.keyword = updated_keyword;
      this.search();
    },
  },
  watch: {
    //keywordに変更があった時に発火。キーワードが空でなければshow=trueとして検索履歴表示
    keyword: function () {
      if (this.keyword) {
        this.keywordToURL = this.keyword
          .replace(/[%％]/g, "%2525") //#と同様のクエリに関わるモノのエスケープ
          .replace(/[&＆]/g, "%2526")
          .replace(/[+＋]/g, "%252B")
          .replace(/[#＃]/g, "%2523")
          .replace(/[?？]/g, "%253F")
          .replace(/[=＝]/g, "%253D");
      }
    },
    $route() {
      //URLにreview,bbs,userが含まれない場合は検索窓を空にする
      if (!this.$route.path.match(/review|bbs|user/)) {
        this.keyword = "";
      } else {
        this.keyword = this.k;
      }
    },
  },
  created() {
    let uri = window.location.href.split("?");
    if (uri.length == 2) {
      let vars = uri[1].split("&");
      let getVars = {};
      let tmp = "";
      vars.forEach(function (v) {
        tmp = v.split("=");
        if (tmp.length == 2) getVars[tmp[0]] = tmp[1];
      });
      if (getVars["s"] !== undefined) {
        this.keyword = decodeURI(getVars["s"]);
      }
    }
  },
  computed: {
    ...mapState({
      k: (state) => state.search_query.keyword,
    }),
    newRoute() {
      var newRoute = this.$route.fullPath;
      if (this.keyword) {
        this.keywordToURL = this.keyword
          .replace(/[%％]/g, "%2525") //#と同様のクエリに関わるモノのエスケープ
          .replace(/[&＆]/g, "%2526")
          .replace(/[+＋]/g, "%252B")
          .replace(/[#＃]/g, "%2523")
          .replace(/[?？]/g, "%253F")
          .replace(/[=＝]/g, "%253D");
      }

      var keywordQuerySign = "?s=";
      var hallQuerySign = "&hall=";
      //キーワードない場合、?S=をなくす
      if (!this.keyword) {
        var keywordQuerySign = "";
        //キーワードがなく、式場選択のあるなしでクエリ表示変更
        if (this.$route.query.hall) {
          hallQuerySign = "?hall=";
        }
      }
      if (!this.$route.query.hall) {
        hallQuerySign = "";
      }
      if (!sort) {
        sort = "post";
      }

      //modeがある、つまり検索場所でmodeで特定できていればそのmodeに関するキーワード検索を行う
      if (this.$route.params.mode) {
        //modeがtagでない場合
        if (this.$route.params.mode !== "tag") {
          newRoute = `/${this.$route.params.mode}/${this.$route.params.param1}/${this.$route.params.param2}/${sort}${keywordQuerySign}${this.keywordToURL}${hallQuerySign}${this.$route.query.hall}`;
        } else {
          //modeがtagである場合は、tagModeをreviewかbbsか指定しなければならないのでparam2で指定。ないときはtagModeにreviewを入れる。
          var tagMode = this.$route.params.param2;
          var sort = this.$route.params.sort;
          if (!tagMode) {
            tagMode = "review";
          }
          newRoute = `/${this.$route.params.mode}/${tagMode}/${sort}${keywordQuerySign}${this.keywordToURL}`;
        }
      } else {
        newRoute = `/review/post?s=${this.keywordToURL}`;
      }
      newRoute = newRoute
        .replace(/\/null/g, "")
        .replace(/\/\?s=undefined/g, "")
        .replace(/\/undefined/g, "")
        .replace(/undefined/g, "")
        .replace(/null/g, "");
      // newRoute = newRoute.replace(/[#＃]/g, '%2523')
      //                     .replace(/[%％]/g, '%2525') //#と同様のクエリに関わるモノのエスケープ
      //                     .replace(/[?？]/g, '%253F')
      //                     .replace(/[=＝]/g, '%253D')

      return newRoute;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SearchForm.vue